
export const getTokenFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('token');
};

export const isAnimatedImage = isAnimated => isAnimated === true;
